import qs from 'qs';
import _ from 'lodash';
import set from 'lodash/set';
import Form from '@jgile/laravel-vue/resources/js/forms/Form';

const filterParams = function (prefix, value) {
    if (prefix === '$form') {
        return;
    }

    if (value === null) {
        return;
    }

    return value;
};

export default class Query {
    constructor(attributes) {
        Object.defineProperty(this, '$form', {
            value: new Form(),
            enumerable: false,
        });

        Object.defineProperty(this, '$withHistory', {
            value: false,
            enumerable: false,
            writable: true,
        });

        this.set(
            _.merge(
                {
                    filter: {},
                    sort: null,
                    append: [],
                    include: [],
                    fields: [],
                    perPage: null,
                    page: null,
                },
                attributes,
            ),
        );
    }

    set(attribute, value) {
        if (_.isPlainObject(attribute)) {
            _.each(attribute, (value, key) => {
                this.set(key, value);
            });

            return;
        }

        set(this, attribute, value);

        return this;
    }

    url(baseUrl = '/', params = {}) {
        return baseUrl + '?' + this.toQueryString(_.merge({}, this, params));
    }

    toQueryString(queryObject) {
        return qs.stringify(queryObject, {
            encode: false,
            filter: filterParams,
            arrayFormat: 'brackets',
        });
    }

    toQueryObject(queryString) {
        return qs.parse(queryString, { ignoreQueryPrefix: true });
    }

    fromQueryString(queryString, defaultQuery = {}) {
        this.set(_.merge({}, defaultQuery, this.toQueryObject(queryString)));
        return this;
    }

    fromUrl(defaultQuery = {}) {
        this.set(_.merge({}, defaultQuery, this.toQueryObject(window.location.search)));
        return this;
    }

    get(baseUrl) {
        return this.$form.get(this.url(baseUrl));
    }

    post(baseUrl, data = {}) {
        return this.$form.post(this.url(baseUrl), data);
    }

    put(baseUrl, data = {}) {
        return this.$form.put(this.url(baseUrl), data);
    }

    delete(baseUrl) {
        return this.$form.delete(this.url(baseUrl));
    }

    withHistory(history = true) {
        this.$withHistory = history;
        return this;
    }

    pushHistory() {
        const queryString = this.toQueryString(this);
        const url = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
        window.history.replaceState(null, null, url);

        return this;
    }
}
